import * as React from 'react';
import TerminalStatusList from './TerminalStatusList'

export default function Dashboard() {
  return <TerminalStatusList />;
}
